import { InjectionToken } from '@angular/core';
import { AccountGroup, ProjectionFilter, ReadFilter } from '@galaxy/account-group';
import { Package } from '@vendasta/marketplace-packages';
import { User } from '@vendasta/store';
import { Observable } from 'rxjs';

// Must be provided in the root
export interface CoreOrderConfig {
  automationsOrderWorkflowEnabled$: Observable<boolean>;
  getMultiPackages(packageIds: string[]): Observable<Package[]>;
  listenToBusiness(
    businessId: string,
    mask: Partial<ProjectionFilter>,
    readFilter?: Partial<ReadFilter>,
  ): Observable<AccountGroup>;
  listenToBusinessUsers(partnerId: string, businessId: string): Observable<User[]>;
}

export type OrderPermissions = {
  accessMarketplace: boolean;
  accessManageOrders: boolean;
};

export interface PageOrderConfig {
  orderId$: Observable<string>;
  businessId$?: Observable<string> | undefined;
  previousPageUrl$?: Observable<string>;
  orderPermissions$?: Observable<OrderPermissions>;
  userCanAccessRetailBilling$?: Observable<boolean>;
  userCanAccessWholeSaleBilling$?: Observable<boolean>;
  invoicesPageUrl$?: Observable<string>;
  getOrderUrl?(orderId: string, businessId: string): string;
}

export interface OrderBusinessConfig {
  getBusinessUrl?(businessId: string): string | Promise<string>;
}

export const CORE_ORDER_CONFIG_TOKEN = new InjectionToken<CoreOrderConfig>(
  '[Orders]: Injection token for global config',
);

export const PAGE_ORDER_CONFIG_TOKEN = new InjectionToken<PageOrderConfig>(
  '[Orders]: Injection token for a page looking at an individual order',
);

export const ORDER_BUSINESS_CONFIG_TOKEN = new InjectionToken<OrderBusinessConfig>(
  '[Orders]: Injection token for business-specific config',
);
